function getLoginUserUuid(loginInformation) {
    if (loginInformation == null) {
        return '';
    }
    try {
        const parsed = typeof loginInformation === 'string'
            ? JSON.parse(loginInformation)
            : loginInformation;
        return parsed != null && parsed.objectData != null && parsed.objectData.userUuid != null
            ? String(parsed.objectData.userUuid)
            : '';
    } catch (error) {
        return '';
    }
}

function getStoredLoginUserUuid() {
    return getLoginUserUuid(localStorage.getItem('loginInformation'));
}

let tabLoginUserUuid = getStoredLoginUserUuid();
let tabAuthenticationInvalidated = false;

export function markCurrentTabAuthenticated(loginInformation) {
    tabLoginUserUuid = getLoginUserUuid(loginInformation);
    tabAuthenticationInvalidated = false;
}

export function invalidateCurrentTabAuthentication() {
    tabAuthenticationInvalidated = true;
}

export function isCurrentTabAuthenticationInvalidated() {
    if (tabAuthenticationInvalidated) {
        return true;
    }
    return tabLoginUserUuid !== '' && getStoredLoginUserUuid() !== tabLoginUserUuid;
}

export function shouldInvalidateForLoginStorageEvent(event) {
    if (event.storageArea !== localStorage
        || (event.key !== null && event.key !== 'loginInformation')) {
        return false;
    }
    return isCurrentTabAuthenticationInvalidated();
}
